import { motionDurations, motionEasings } from "@hightouch/htui";

/** The nav's choreography, in seconds for motion, with every step on an htui preset. */
export const navMotion = {
  /** The sidebar and the page sliding together when the sidebar collapses, or docks again. */
  foldDuration: motionDurations.normal,
  unfoldDuration: motionDurations.slow,
  foldEase: motionEasings.easeInOutCubic,
} as const;

/** Hover intent, in ms for timers: a passing pointer never peeks the sidebar, and a short slip off it never closes it. */
export const MINI_NAV_PEEK_DELAY_MS = 150;
export const MINI_NAV_PEEK_GRACE_MS = 300;
